










import { Vue, Component } from 'vue-property-decorator';
import { Banner, BottomTabbar } from '@/components';
import * as config from './config';
import { getBaseinfo } from '@/api/api';
@Component({
  components: {
    Banner,
    BottomTabbar,
  },
})
export default class Home extends Vue {
  bannerSrc = require('./img/banner.jpg');
  option = config.OPTHINES;
  async created() {
    getBaseinfo('2020project/2020searchstar').then((res: any) => {
      this.$addPv(res.data.activityId);
      console.log('活动id', res.data.activityId);

      // 分享
      setTimeout(() => {
        this.$appShareInfo({
          title: '寻找城市匠星 | 天怡美装饰第三届工程工艺比武大赛',
          url: window.location.href,
          subtitle:
            '全面提升品质工程打造能力，催生大批优质工艺，引领行业工程标准',
          classId: -1,
          id: -1,
          image: 'https://image2.cqcb.com/d/file/Rka8198G4fdrZSAb3WBHF66RDB1LfczaS7y8ei1m.jpeg',
          type: 3,
        });
      }, 500);
      this.$wxShareInfo({
        title: '寻找城市匠星 | 天怡美装饰第三届工程工艺比武大赛',
        subtitle:
          '全面提升品质工程打造能力，催生大批优质工艺，引领行业工程标准',
        image: 'https://image2.cqcb.com/d/file/Rka8198G4fdrZSAb3WBHF66RDB1LfczaS7y8ei1m.jpeg',
      });
    });
  }
}
